import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED, TRACK_STATE_DIFFICULTY } from "../../../config/constants";

const Track2BRed = ({ state, workState, onLabelClick }) => {
	const trackColor = getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED);
	return (
		<g id="Track2BRed" transform="translate(1124.000000, 683.000000)" className="track">
			<path
				d="M31.9419597,12 L47.9961996,10.8972914 C66.0711887,9.65578469 84.1438982,13.348112 100.283477,21.5797927 L256,101 L256,101"
				id="path-4"/>

			<g id="line" strokeLinecap="round">
				<use strokeOpacity="0" stroke="#FFFFFF" strokeWidth="9" xlinkHref="#path-4"/>
				<use stroke={state === TRACK_STATE_DIFFICULTY ? "url(#linearGradient-3)" : trackColor} strokeWidth={tracksWidth}
						 xlinkHref="#path-4"/>
			</g>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track2BRed')}
				coords="73.000000, 0.000000"
				text="2B"
				textCoordsX="10.6489258"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			/>
		</g>
	)
};

Track2BRed.propTypes = trackPropTypes;

export default Track2BRed;
